module.exports = SharedDependencies.MobX['@servicetitan/cpb-host'];